export const MODULES = [
  { code: 'R01', title: 'Financial Services, Regulation and Ethics' },
  { code: 'R02', title: 'Investment Principles and Risk' },
  { code: 'R03', title: 'Personal Taxation' },
  { code: 'R04', title: 'Pensions and Retirement Planning' },
  { code: 'R05', title: 'Financial Protection' },
  { code: 'R06', title: 'Financial Planning Practice' },
  { code: 'CF6', title: 'Mortgage Advice' },
  { code: 'CF8', title: 'Long Term Care Insurance' },
] as const;

/** Modules that are coming soon and not yet available */
export const COMING_SOON_MODULES = ['R06'] as const;

export const isComingSoon = (code: string) =>
  (COMING_SOON_MODULES as readonly string[]).includes(code.toUpperCase());

export type ModuleCode = typeof MODULES[number]['code'];

export const getModuleTitle = (code: string) =>
  MODULES.find(m => m.code === code)?.title ?? code;

export const CALCULATION_FILTER_MODULES = ['R02', 'R03'] as const;

export const supportsCalculationFilter = (code: string) =>
  (CALCULATION_FILTER_MODULES as readonly string[]).includes(code.toUpperCase());

/** Modules that contain multi-response questions */
export const MULTI_RESPONSE_MODULES = ['R01', 'R02', 'R03', 'R04'] as const;

export const supportsMultiResponseFilter = (code: string) =>
  (MULTI_RESPONSE_MODULES as readonly string[]).includes(code.toUpperCase());

/** Modules that use CII-weighted LO distribution */
export const WEIGHTED_MODULES = ['R01', 'R02', 'R03', 'R04', 'R05', 'CF6', 'CF8'] as const;

/** Default full exam question count per module */
export const MODULE_EXAM_COUNTS: Record<string, number> = {
  R01: 100,
  R02: 100,
  R03: 50,
  R04: 50,
  R05: 50,
  CF6: 125,
  CF8: 75,
};

/** Pass marks (%) used on the per-module Exam Readiness scale */
export const MODULE_PASS_MARKS: Record<string, number> = {
  R01: 65,
  R02: 65,
  R03: 65,
  R04: 65,
  R05: 70,
  CF6: 70,
  CF8: 70,
};

/** Total questions available in each module's question bank */
export const MODULE_QUESTION_BANK_TOTALS: Record<string, number> = {
  // R01 bank holds 408 live questions; progress is reported against 400.
  R01: 400,
  R02: 400,
  R03: 400,
  R04: 400,
  R05: 400,
  CF6: 360,
  CF8: 375,
};

export const getModuleQuestionBankTotal = (code: string) =>
  MODULE_QUESTION_BANK_TOTALS[code.toUpperCase()] ?? 300;

/**
 * Modules that have a dedicated Section B made up of case studies, each with
 * a fixed number of linked MCQs. The case-study questions live under a
 * dedicated learning outcome (e.g. CF6 → LO16, CF8 → LO15).
 */
export const CASE_STUDY_MODULES: Record<string, { lo: string; totalCs: number; qsPerCs: number; csQuestions: number }> = {
  CF6: { lo: 'LO16', totalCs: 5, qsPerCs: 5, csQuestions: 25 },
  CF8: { lo: 'LO15', totalCs: 5, qsPerCs: 5, csQuestions: 25 },
};

export const isCaseStudyModule = (code: string) => code.toUpperCase() in CASE_STUDY_MODULES;
export const getCaseStudyLo = (code: string) => CASE_STUDY_MODULES[code.toUpperCase()]?.lo;
